import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

const AccessTicketOptionStatusPill = (props: {className: string; children: React.ReactNode | React.ReactNode[]}) => {
    const {t} = useTranslation();
    return (
        <div
            className={clsx(
                "AccessTicketOptionStatusPill text-black text-xxs md:text-base flex flex-col items-center rounded-[5px] shrink-0 py-[4px] md:py-[5px] px-[10px] overflow-hidden",
                props.className
            )}
        >
            {props.children}
        </div>
    );
};

export default AccessTicketOptionStatusPill;
